
import styles from "./styles/Inbox.module.scss";


import { FiSend } from "react-icons/fi";
import { IoIosArrowBack } from "react-icons/io";
import { v4 as uuidv4 } from "uuid";

import { Description, SubTitle } from "Components/CustomComponents";
import { formatTimestamp } from "Helper";
import { useEffect, useMemo, useRef, useState } from "react";
import { Image, Spinner } from "react-bootstrap";
import { useChatContext } from "../context/ChatContext";
import { useSocket } from "../../../Context/SocketContext";
import socketInstance from "../../../config/socket"
import { useSelector } from "react-redux";
import { RootState } from "../../../store";
import _ from "lodash";
import { useInView } from "react-intersection-observer";

interface ComponentProps {
  isMobile?: boolean;
}


const Inbox: React.FC<ComponentProps> = ({ isMobile = false }) => {
  const messageRef = useRef<HTMLInputElement>(null);
  const { ref, inView } = useInView({
    threshold: 0,
  });
  const socket: typeof socketInstance | null = useSocket();
  const { isSocketConnected, user: authUser } = useSelector((state: RootState) => state.auth)
  const { chatRoom, setChatRoom, updateLastMessagePayload } = useChatContext();
  // const socket = useSocket()

  const LIMIT = 20;
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState<Partial<PaginationInterface>>({})
  const INITIAL_CHAT_HISTORY = useMemo(() => {
    return {
      isError: false,
      isLoading: true,
      data: [],
    };
  }, []);

  const [chatHistory, setChatHistory] = useState<ChatMessageListingType>(INITIAL_CHAT_HISTORY)
  const [user] = useState<Partial<User>>({
    id: authUser?.id,
    name: authUser?.firstname + ' ' + authUser?.lastname,
    image_url: authUser?.image_url
  });



  useEffect(() => {
    if (isSocketConnected) {
      socket?.on('loadChatHistory_', (data: SocketResponseInterface<ChatMessageType[], unknown>) => {
        const links: Partial<PaginationInterface> = data?.links;
        setChatHistory(prev => {
          return {
            ...prev,
            isLoading: false,
            data: ((links.current || 0) > 1) ? [...prev.data, ...data.data.reverse()] : data.data.reverse()
          }
        })
        setPagination(links)
      })
    }

    return () => {
      if (isSocketConnected) {
        socket?.dispose('loadChatHistory_')
      }
    }

  }, [isSocketConnected])

  useEffect(() => {
    if (chatRoom?.chat_room_id) {
      socket?.emit("_loadChatHistory", { chat_room_id: chatRoom?.chat_room_id, limit: LIMIT })
    }
  }, [chatRoom?.chat_room_id])



  useEffect(() => {
    if (inView) {
      setChatHistory(prev => {
        return {
          ...prev,
          isLoading: true
        }
      })
      setPage(prev => prev + 1);
    }
  }, [inView])

  useEffect(() => {
    if (page > 1) {
      socket?.emit("_loadChatHistory", { chat_room_id: chatRoom?.chat_room_id, page: page, limit: LIMIT })
    }
  }, [page])

  useEffect(() => {
    if (isSocketConnected) {
      socket?.on('receivedMessage_', (data: SocketResponseInterface<ChatMessageType, SendMessageType>) => {
        const message: ChatMessageType = data?.data

        if (message?.chat_room_id !== chatRoom.chat_room_id) return;
        if (message.user_id !== user?.id) {
          setChatHistory(prev => {
            return {
              ...prev,
              data: [
                message,
                ...prev.data,
              ]
            }
          })
        }
        else {
          const payload: SendMessageType | undefined = data?.payload;
          if (_.isUndefined(payload?.message_uuid)) {
            setChatHistory(prev => {
              return {
                ...prev,
                data: [
                  message,
                  ...prev.data,
                ]
              }
            })
          }
          else {
            setChatHistory(prev => {
              return {
                ...prev,
                data: [
                  message,
                  ...prev.data.filter(item => item.message_uuid !== payload?.message_uuid),
                ]
              }
            })
          }
        }
        updateLastMessagePayload(message)
        socket?.emit('_resetMessageCount', { chat_room_id: chatRoom?.chat_room_id })
      })
    }

    return () => {
      if (isSocketConnected) {
        socket?.dispose('receivedMessage_')
      }
    }

  }, [isSocketConnected, chatRoom, user])


  // useEffect(() => {
  //   // scrollChatContainer()
  // }, [chatHistory?.data.length])



  const handleBackButtonClick = () => {
    setChatRoom({});
  };


  // function scrollChatContainer() {
  //   const container = document.getElementById('chatContainer')
  //   container?.scroll({ top: container.scrollHeight, behavior: 'smooth' });
  // }

  const handleSendMessage = async () => {
    const message = messageRef?.current?.value;
    if (!message) return;
    if (!chatRoom.chat_room_id) return;

    const payload: SendMessageType = {
      message_type: 'TEXT',
      message: message,
      message_uuid: uuidv4(),
      chat_room_id: chatRoom.chat_room_id
    }


    setChatHistory((prev) => {
      return {
        ...prev,
        data: [
          {
            ...payload,
            user_id: user.id,
            user_name: user.name ?? '',
            user_image: user.image_url ?? '',
            message_timestamp: new Date(),
          },
          ...prev.data,
        ]
      }
    })
    socket?.emit('_sendMessage', payload);
    messageRef.current.value = ''

  }


  return (

    <div className={styles.Inbox}>
      <div className={styles.titleContainer}>
        <div className={styles.userContainer}>
          <div className={styles.imageContainer}>
            {isMobile ? (
              <span className={styles.backButton} onClick={handleBackButtonClick}>
                <IoIosArrowBack />
              </span>
            ) : (
              ""
            )}

            <Image
              className={styles.image}
              src={chatRoom?.image_url}
              alt="User Profile"
              width={70}
              height={70}
            />
            {/* <span className={`online`}></span> */}
          </div>
          <div className={styles.nameContainer}>
            <SubTitle text={chatRoom?.room_name} classes="lc-1" />
            {/* <Description text="Online" classes="fs-75" /> */}
          </div>
        </div>
      </div>
      <div className={styles.chatContainer} id="chatContainer">
        {
          chatHistory?.data?.map((item: ChatMessageType, index) => {
            const isMe = user?.id === item.user_id;

            return (
              <div
                key={index}
                className={`${styles.chat} ${isMe ? styles.me : ""}`}
                ref={
                  ((chatHistory?.data.length < (pagination?.total_records ?? 0)) &&
                    (index === (chatHistory?.data.length - 1))) ? ref : null}
              >
                <Description text={isMe ? "You" : item.user_name} classes="fs-8 mb-2 mx-4" />
                <p className={`${styles.message} ${isMe ? styles.me : ""}`}>
                  {item?.message}
                </p>
                <Description text={formatTimestamp(item?.message_timestamp)} classes="fs-8 mt-2 mx-4" />
                <span className={styles.info}>Seen</span>
              </div>
            );
          })}
        {chatHistory?.isLoading ?
          <div className="make-center"><Spinner /></div>
          : ""}
      </div>

      <div className={styles.messageContainer}>
        <input placeholder="Type a message ..." className={styles.messageInput} ref={messageRef}
        />
        <button className={`${styles.sendButton} bg`} onClick={handleSendMessage}>
          <FiSend />
        </button>
      </div>
    </div >
  );
}


export default Inbox